import { get, post, put, fileDown } from "@/utils/request";

import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getSystemLogList = data =>
  post(`${riskApi}/risk/log/list`, data);

export const downSystemLogList = (data, fileName) =>
  fileDown(`${riskApi}/risk/log/export`, data, fileName);
